import AOS from 'aos';
import { throttle, debounce } from 'underscore'; //https://underscorejs.org
// import Modal from 'bootstrap/js/dist/modal';


// custom jquery below
jQuery(document).ready(function ($) {
    'use strict';

    // FADE IN CONTENT ON PAGE LOAD
    setTimeout(function () {
        $('body').addClass('delayfade');
    }, 200);

    // animate on scroll init - https://michalsnik.github.io/aos/
    AOS.init();

    /*****************************************************
    **************** MENU FUNCTIONALITY ******************
    *****************************************************/
    const $body = $('body');
    const $navToggle = $('#navToggle');
    let navState = 'desktop';
    const mobileBreakpoint = 575;


    // SET NAVSATE / INIT
    const setNavState = function() {

        if( $(window).width() > mobileBreakpoint ) {

            navState = 'desktop';
            $navToggle.removeClass('nav-open');
            $body.removeClass('nav-open');

        } else {

            navState = 'mobile';

        }
    }

    $navToggle.click(function(e) {

        if( !$(e.currentTarget).hasClass('nav-open') ) {

            $(e.currentTarget).addClass('nav-open');
            $body.addClass('nav-open');

        } else {

            $(e.currentTarget).removeClass('nav-open');
            $body.removeClass('nav-open');

        }

    });

    setNavState();
    $(window).resize(
        debounce(setNavState, 300)
    );

    /**************** END MENU FUNCTIONALITY ******************/

});
